import { ele } from "cables-shared-client";
import api from "../api.js";
import web from "../index.js";

export default class PageTags
{
    constructor(targetElement)
    {
        // (targetEl, tagName)
        const tagName = targetElement.dataset.tagname;
        this.projects = web.projects;
        this.getTagProjects(tagName);
    }

    getTagProjects(name)
    {
        api.get("tag/" + name + "/projects", (result) =>
        {
            let html = "";
            for (const i in result.projects)
            {
                const project = result.projects[i];
                const projectInfo = web.getHandleBarHtml("project_info", { "project": project, "user": { "_id": project.userId, "username": project.cachedUsername } });
                html += web.getHandleBarHtml("project", { "project": project, "projectInfo": projectInfo });
            }
            const tagArr = this.projects.getTagsFromProjects(result.projects);

            web.setHandleBarHtml("tags", { "tags": tagArr }, ele.byId("tags"));
            ele.byId("tag_projects").innerHTML = html;

            if (!result.projects || result.projects.length === 0) ele.byId("tag_projects").innerText = "No Projects found.";
        });
    }
}
